<template>
	<information-card
		title="Escoger Evaluadores"
		sub-title="Instrucciones"
	>
		<div slot="content">
			<p class="textjustify">Selecciona los evaluadores para cada empleado.
			</p>
			<br>
			<div class="content-rule">
				<br>
				<p>Paso 1:<span class="text-color"> Click seleccionar evaluadores.</span></p>
                <p>Paso 2:<span class="text-color"> Asignar evaluadores a los empleados.</span></p>
                <p>Paso 3:<span class="text-color"> Escoge un grado para cada evaluador.</span></p>
			</div>
			<div class="content-graphic  mt-4">
				<p :style="`color:${$appColors.primary}; margin-top: 0px; max-height: 2px;`">GRADOS DE REFERENCIAS</p>
			</div>
			<div class="content-graphic mt-2">
				<div class="box-reference">
					<p :style="`color:${$appColors.secondary}; max-height: 8px;`">AUTOEVALUACIÓN</p>
				</div>
				<div class="content-file">
					<div class="content-graphic">
						<div class="box-reference">
							<p :style="`color:${$appColors.secondary}; max-height: 8px;`">JEFE</p>
						</div>
						<div class="box-reference">
							<p :style="`color:${$appColors.secondary}; max-height: 8px;`">PAR</p>
						</div>
						<div class="box-reference">
							<p :style="`color:${$appColors.secondary}; max-height: 8px;`">COLABORADOR</p>
						</div>
						<div class="box-reference">
							<p :style="`color:${$appColors.secondary}; max-height: 8px;`">CLIENTE INTERNO</p>
						</div>
					</div>
					<div class="box-reference">
						<p :style="`color:${$appColors.secondary};`">Todos los observadores</p>
					</div>
				</div>
			</div>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'process-model-description-evaluator',
	components: {
		InformationCard,
	},
};

</script>

<style lang="scss" scoped>
.textjustify {
	text-align: center;
	font-size: 12px;
}
.content-rule {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	border: 1px solid map-get($colors, gray-slider);
	background-color: #F9F9F9;
    padding: 0 20px;
	border-radius: 4px;
	font-size: 10px;
}
.content-graphic {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	height: auto !important;
	border: 1px solid map-get($colors, green-dark);
	border-radius: 4px;
	font-size: 10px;
	padding: 5px 10px;
}
.box-reference {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	width: 100%;
	border: 1px solid map-get($colors, orange-dark);
	background-color: map-get($colors, orange-low);
	border-radius: 4px;
	font-size: 10px;
	margin: 5px; 
	padding: 2px 10px;
}
.content-file {
	display: grid;
	grid-template-columns: 1.2fr 0.8fr;
	width: 100%;
	padding: 0 5px 0 0;
}
.text-color {
	color: #f09c2e;
}
.table-info {
	border: #f09c2e 1px solid;
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.row-table-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
}
.btn-model {
	background-color: #F9F9F9;
	width: 50px;
	height: 25px;
	border-radius: 8px;

}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-model-description-evaluator.vue